/**
 * The method a backup code answers a second factor as: the name the server's method lists carry — a sign-in challenge's
 * `mfaMethods`, the step-up's `GET <endpoint>/methods` — exactly when the person holds unused backup codes and the route
 * takes one (F-PASSKEY-HOST, 2026-10-24). It is the account's way out, never a method to pick from the list: the
 * challenge view offers it as its own link, and as the answer when nothing else can be used here.
 *
 * @module @puffin-core/mfa-ui/internal/backupMethod
 */

export const BACKUP_METHOD = 'backup';
